module.exports = __webpack_public_path__ + "static/media/hot_myrcene_tonic.b1877ed9.png";